import { FormContext } from '@agtech/core/forms/AgTechFormContext';
import { AgTechFormControlProps } from '@agtech/core/forms/AgTechFormControls';
import { useAgTechSafeState } from '@agtech/core/utilities/AgTechUtilities';
import React, { useContext } from 'react'
import AgTechToggle from '../../Widgets/AgTechToggle';

export type AgTechFormToggleControlProps<TEntity> = AgTechFormControlProps<TEntity, boolean> & {
    toggle?: (isToggled: boolean, onToggleChanged: (wasChecked: boolean) => void) => React.ReactNode
}

export const AgTechFormToggleControl = <TEntity, >(props: AgTechFormToggleControlProps<TEntity>) => {
    let formContext = useContext(FormContext);
    let formControlWidth: string = `${props.width ?? 50}%`;

    let [isChecked, setIsChecked] = useAgTechSafeState(props.value(formContext.entity) ?? false);

    let handleToggleToggled = (wasChecked: boolean) => {

        if (props.readonly) {
            return;
        }

        if (props.onControlValueChanged) {
            let updatedValue = wasChecked;
            formContext.handleFieldChanged(updatedValue, props.onControlValueChanged);
        }

        setIsChecked(wasChecked);
    }

    return (
        <div className='row-based flexed pr-5 flex' style={{maxWidth: formControlWidth}}>
            { props.toggle ? props.toggle(isChecked.current, handleToggleToggled) : (
                <AgTechToggle
                    caption={props.caption}
                    isToggled={isChecked.current}
                    onToggled={() => handleToggleToggled(!isChecked.current)}
                    setting={{
                        disabled: props.readonly
                    }}
                />
            )}         
        </div>
    );
};